module.exports = __webpack_public_path__ + "static/29-88d4fe4a896847d7c89a4278fb8c8d88.jpg";